import { render } from "./order-search.vue?vue&type=template&id=223d6b38&scoped=true"
import script from "./order-search.vue?vue&type=script&lang=js"
export * from "./order-search.vue?vue&type=script&lang=js"

import "./order-search.vue?vue&type=style&index=0&id=223d6b38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223d6b38"]])

export default __exports__